const NoResultIcon = () => {
  return (
    <svg
      width="302"
      height="200"
      viewBox="0 0 302 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M98.0458 198.986H1C1 172.224 22.7149 150.547 49.5229 150.547C62.0254 150.547 73.4093 155.25 82.0031 163.002C91.8604 171.856 98.0458 184.705 98.0458 198.986Z"
        fill="#F7F7F7"
        stroke="#12183E"
        strokeWidth="0.881186"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M243.313 198.986H146.268C146.268 172.224 167.982 150.547 194.79 150.547C207.293 150.547 218.677 155.25 227.271 163.002C237.128 171.856 243.313 184.705 243.313 198.986Z"
        fill="#F7F7F7"
        stroke="#12183E"
        strokeWidth="0.881186"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M194.79 139.547C208.876 139.547 220.295 128.148 220.295 114.086C220.295 100.024 208.876 88.625 194.79 88.625C180.704 88.625 169.285 100.024 169.285 114.086C169.285 128.148 180.704 139.547 194.79 139.547Z"
        fill="#F7F7F7"
        stroke="#12183E"
        strokeWidth="0.881186"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M49.5227 139.547C63.6088 139.547 75.0278 128.148 75.0278 114.086C75.0278 100.024 63.6088 88.625 49.5227 88.625C35.4366 88.625 24.0176 100.024 24.0176 114.086C24.0176 128.148 35.4366 139.547 49.5227 139.547Z"
        fill="#F7F7F7"
        stroke="#12183E"
        strokeWidth="0.881186"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.8"
        d="M112.033 198.579H52.1113C56.4168 178.689 71.2409 161.971 91.4511 152.836C104.097 164.092 112.033 180.426 112.033 198.579Z"
        fill="#3591FE"
      />
      <path
        d="M121.205 128.169C137.849 128.169 151.342 114.7 151.342 98.0847C151.342 81.4694 137.849 68 121.205 68C104.561 68 91.0684 81.4694 91.0684 98.0847C91.0684 114.7 104.561 128.169 121.205 128.169Z"
        fill="#CCE4FF"
        stroke="#12183E"
        strokeWidth="0.881186"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M63.8711 199.001C63.8711 167.379 89.5448 141.75 121.221 141.75C152.897 141.75 178.571 167.379 178.571 199.001H63.8711Z"
        fill="#CCE4FF"
        stroke="#12183E"
        strokeWidth="0.881186"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M220.657 79.2884L215.494 89.0312L236.591 100.173L241.755 90.4302L220.657 79.2884Z"
        fill="#E8E8E8"
        stroke="#12183E"
        strokeWidth="0.881186"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M234.569 87.1043L229.797 96.1094L236.114 99.4453L240.886 90.4402L234.569 87.1043Z"
        fill="#E8E8E8"
      />
      <path
        d="M212.499 82.8962L212.499 82.8961C224.881 59.5306 215.949 30.5729 192.556 18.2125L192.556 18.2124C169.151 5.85222 140.144 14.7801 127.762 38.1333L127.762 38.1333C115.38 61.499 124.312 90.4566 147.717 102.817L147.717 102.817C171.122 115.165 200.117 106.249 212.499 82.8962ZM119.203 33.6115C134.084 5.52828 168.954 -5.18663 197.087 9.66977C225.219 24.5258 235.952 59.3349 221.07 87.4179C206.189 115.501 171.319 126.216 143.186 111.36C115.054 96.5036 104.321 61.6946 119.203 33.6115Z"
        fill="#545454"
        stroke="#12183E"
        strokeWidth="0.881186"
      />
      <path
        d="M215.201 81.1469C202.933 104.285 174.205 113.12 151.015 100.885C127.824 88.6377 118.975 59.9468 131.243 36.7968C143.511 13.6586 172.251 4.81231 195.441 17.0591C218.62 29.306 227.469 57.9969 215.201 81.1469Z"
        fill="white"
        fillOpacity="0.5"
      />
      <path
        d="M200.383 7.74111C172.035 -7.22857 136.899 3.56767 121.903 31.8662C106.908 60.1647 117.722 95.2406 146.07 110.21C174.417 125.18 209.554 114.384 224.549 86.0852C239.545 57.7867 228.73 22.7108 200.383 7.74111V7.74111ZM215.199 81.1508C202.931 104.289 174.203 113.123 151.013 100.888C127.823 88.6415 118.973 59.9507 131.241 36.8006C143.509 13.6624 172.25 4.81613 195.44 17.063C218.618 29.3098 227.467 58.0007 215.199 81.1508Z"
        fill="#F7F7F7"
        stroke="#12183E"
        strokeWidth="0.881186"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        width="27.7795"
        height="66.1191"
        rx="12.3366"
        transform="matrix(0.475734 -0.879589 0.880275 0.474464 229.584 106.52)"
        fill="#025ECB"
        stroke="#12183E"
        strokeWidth="0.881186"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default NoResultIcon;
